import Styled from './InsightCard.styled';

interface Props {
  body?: string;
  description?: string;
  title?: string;
  value: string;
}

function InsightCard({ title, body, value, description }: Props) {
  return (
    <Styled.Root>
      {title ? <Styled.CardTitle>{title}</Styled.CardTitle> : null}
      {body ? <Styled.Body>{body}</Styled.Body> : null}
      <Styled.Value>{value}</Styled.Value>
      {description ? (
        <Styled.Description>{description}</Styled.Description>
      ) : null}
    </Styled.Root>
  );
}

export default InsightCard;
